 
import { useTranslation } from 'react-i18next'
import { Controller, type ControllerProps as ReactHookFormControllerProps, type FieldValues } from 'react-hook-form'
import { Select, type SelectProps } from 'settle-ui/components/Select/Select'

type ControllerProps<T extends FieldValues> = Pick<
  ReactHookFormControllerProps<T>,
  'name' | 'rules' | 'control' | 'defaultValue' | 'shouldUnregister' | 'disabled'
>
export type SelectControllerProps<T extends FieldValues> = Omit<SelectProps<T[keyof T]>, 'value'> & ControllerProps<T>

 
export const SelectController = <T extends FieldValues>({
  name,
  rules,
  control,
  children,
  defaultValue,
  shouldUnregister,
  required = false,
  warning,
  id,
  disabled,
  ...props
}: SelectControllerProps<T>): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Controller
      name={name}
      rules={{ required: { value: required, message: t('validation::cantBeEmpty') }, ...rules }}
      control={control}
      defaultValue={defaultValue}
      shouldUnregister={shouldUnregister}
      render={({ field, fieldState }) => (
        <Select
          id={id}
          warning={warning}
          {...props}
          required={required}
          disabled={disabled}
          value={field.value || ''}
          error={fieldState.error?.message || Boolean(fieldState.error)}
          onChange={(...args) => {
            field.onChange(...args)
            props.onChange?.(...args)
          }}
        >
          {children}
        </Select>
      )}
    />
  )
}
